<template>
  <v-dialog persistent width="454" :value="true" @keydown.esc="$emit('close')">
    <v-card class="px-6 py-4">
      <v-card-title class="px-0 py-0 mb-6">{{
        $t('filters.rename_filter')
      }}</v-card-title>
      <v-text-field
        v-model="name"
        outlined
        dense
        counter
        :label="`${$t('filters.my_filter_name')}`"
        :maxlength="40"
      />
      <v-card-actions class="justify-end">
        <Button
          color="grey"
          plain
          :disabled="isLoading"
          :text="$t('common.button.cancel')"
          @click="$emit('close')"
        />
        <Button
          plain
          color="blue"
          :loading="isLoading"
          :disabled="isLoading || !name"
          :text="$t('common.button.save')"
          @click="$emit('update', name)"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'

export default {
  props: {
    userFilter: {
      typeof: Object,
      default: {},
    },
    isLoading: {
      typeof: Boolean,
      default: false,
    },
  },
  components: {
    Button,
  },
  data() {
    return {
      name: this.userFilter.name,
    }
  },
}
</script>
